// extracted by mini-css-extract-plugin
export default {"logo":"login_logo__CvEbd","button":"login_button__Gi+2J","google":"login_google__FDJJD"};